import { useEffect } from 'react';
import { useStore } from './store';
import { session } from '../auth/session';
import { NotOwner, SignIn } from '../auth/SignIn';
import { CreateBusiness } from '../auth/CreateBusiness';
import { unwatch, watch } from '../data/live';
import { useModel } from '../data/model';
import { Mark } from '../ui/Mark';
import { Tip, Toast } from '../ui/Overlays';
import { Shell } from './Shell';
import { commandKeys, os } from './platform';
import { track } from '../data/analytics';
import { resetUi } from './ui';
import { closeDialog } from './dialogs';
import { resetPending } from '../data/pending';
import { toggleCmdk } from '../ui/CommandBar';

/** Signed out: the sign-in page. Signed in as a business's owner: their control room. Anyone else: why not. */
export function Root() {
  const { gate } = useStore(session);
  const uid = gate.state === 'owner' ? gate.user.uid : null;
  useEffect(() => {
    if (!uid) return;
    watch(uid);
    // Which computer the control room is used on, and which keys it showed (the audit and analytics trail).
    track('control_room_opened', { os, shortcut: commandKeys });
    return () => {
      unwatch();
      // A shared computer: what this owner had open, planned or pending doesn't wait for the next one.
      resetUi();
      resetPending();
      closeDialog();
      toggleCmdk(false);
    };
  }, [uid]);
  return (
    <>
      {gate.state === 'loading' || gate.state === 'checking' ? (
        <div className="gate">
          <Mark className="gate-mark pulse" />
          {gate.state === 'checking' && gate.offline && <p className="cap gate-note">Waiting for the connection. This opens on its own when it’s back.</p>}
        </div>
      ) : gate.state === 'signedOut' ? (
        <SignIn />
      ) : gate.state === 'notOwner' ? (
        <NotOwner gate={gate} />
      ) : gate.state === 'newOwner' ? (
        <CreateBusiness user={gate.user} />
      ) : (
        <Owner />
      )}
      <Toast />
      <Tip />
    </>
  );
}

function Owner() {
  const m = useModel();
  return <Shell m={m} />;
}
